import { useMemo } from 'react';

export default ({ data, searchFilter }) => {
  const normalizedData = useMemo(() => {
    const result = [];
    let i = 0;
    let _ttl = 10000;
    while (i < data.length && _ttl--) {
      const option = { ...data[i] };
      const subCategoryCount = option?.subCategories?.length;

      i++;

      option.searchKey = option.name;

      if (option.parentId === undefined) {
        option.children = data
          .slice(i, (i += subCategoryCount))
          .map((child) => {
            option.searchKey += child.name;
            return {
              ...child,
              searchKey: child.name,
            };
          });
      }
      result.push(option);
    }
    return result;
  }, [data]);

  const filteredData = useMemo(() => {
    const _filter = (d) => {
      return d.reduce((acc, el) => {
        const visible = el.searchKey
          .toUpperCase()
          .includes(searchFilter.toUpperCase());
        const clone = { ...el };
        if (visible) {
          if (clone.children && clone.children.length) {
            clone.children = _filter(clone.children);
          }

          return [...acc, clone];
        }

        return acc;
      }, []);
    };
    return _filter(normalizedData);
  }, [normalizedData, searchFilter]);

  return filteredData;
};
